import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LukosConciliacaoPremium } from '../../components/custom/LukosPremiumSolutions/LukosPremiumSolutions';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
import { ReconciliationMockup } from '../../components/custom/LukosEcommerceShowcase/LukosPlatformMockups';
import '../../components/custom/LukosEcommerceShowcase/LukosEcommerceShowcase.css';


const LukosConciliacaoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white pt-24">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <LukosConciliacaoPremium />

        {/* Feature 1: Conciliação Bancária */}
        <section className="les-section bg-white pt-16 pb-24">
          <div className="les-container">
            <div className="les-feature-block">
              <div className="les-content">
                <h3 className="les-title">
                  Conciliação <span>Bancária</span> Automática
                </h3>
                <ul className="les-list">
                  <li className="les-item">
                    <Check className="les-icon" size={20} />
                    <span>Auditoria automática de taxas cobradas por adquirentes e bancos.</span>
                  </li>
                  <li className="les-item">
                    <Check className="les-icon" size={20} />
                    <span>Conciliação em segundos de milhares de transações com um clique.</span>
                  </li>
                  <li className="les-item">
                    <Check className="les-icon" size={20} />
                    <span>Identificação precisa de divergências em repasses e cancelamentos.</span>
                  </li>
                </ul>
                <Link to="/contato" className="les-cta">
                  Falar com especialista <ArrowRight size={18} />
                </Link>
              </div>

              <div className="les-visual">
                <ReconciliationMockup />
              </div>
            </div>
          </div>
        </section>
      </motion.div>
    </div>
  );
};

export default LukosConciliacaoPage;
